"use client";

import classNames from "classnames/bind";
import Cookies from "js-cookie";
import { useState } from "react";
import styles from "./legal-disclaimer.module.css";

const cx = classNames.bind(styles);

export const LegalDisclaimer = ({
  position,
  message,
  link,
  cookieKey,
}: {
  position: "top" | "bottom";
  message: React.ReactNode;
  link?: {
    text: string;
    url: string;
  };
  cookieKey: string;
}) => {
  /**
   * Using cookies here implies that this component is not suitable for
   * server-side rendering (SSR) because it will result in client-side hydration
   * mismatches. As such, this component should only ever be rendered in a
   * browser environment.
   */
  const [isDismissed, setIsDismissed] = useState<boolean>(
    () => Cookies.get(cookieKey) === "dismissed",
  );

  return isDismissed ? null : (
    <div
      id="container-banner"
      className={cx("container", {
        [`container--${position}`]: true,
      })}
    >
      <div className={cx("inner")}>
        <p className={cx("text")}>{message}</p>
        {link && (
          <a className={cx("text", "text--link")} href={link.url}>
            {link.text}
          </a>
        )}
        <a
          className={cx("button")}
          onClick={(event) => {
            event.preventDefault();
            setIsDismissed(true);
            Cookies.set(cookieKey, "dismissed");
          }}
        />
      </div>
    </div>
  );
};
